import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`;

const Container = styled.div<{ $isValid?: boolean, $disabled? :boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: 1px solid
    ${({ $isValid }) =>
      $isValid === undefined || $isValid === null
        ? "#ccc"
        : $isValid
        ? "#ccc"
        : "#FF5A5A"};
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px; /* 오른쪽 요소 공간 확보 */
  background-color: ${({ $disabled })=> $disabled ? '#F5F5F5': 'white'};
`;

const StyledInput = styled.input`
  flex-grow: 1;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  outline: none;
  width: 100%;
  background-color: transparent;
`;

const ChildrenWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #666;
`;

interface Props {
  type?: string;
  defaultValue?: string;
  placeholder?: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  isValid?: boolean;
  pattern?: string;
  title?: string;
  children?: React.ReactNode;
  disabled?:boolean
}

const InputBoxOnBlurChildren = ({
  placeholder,
  defaultValue,
  type = "text",
  onBlur,
  isValid,
  pattern,
  title,
  children,
  disabled
}: Props) => {
  return (
    <Wrapper>
      <Container $isValid={isValid} $disabled={disabled}>
        <StyledInput
          type={type}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onBlur={onBlur}
          pattern={pattern}
          title={title}
          disabled={disabled}
        />
        {children && <ChildrenWrapper>{children}</ChildrenWrapper>}
      </Container>
    </Wrapper>
  );
};

export default InputBoxOnBlurChildren;
